<template>
  <el-dialog
    :title="$t('syncPartnerGoodsStock.confirmTitle')"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose"
  >
    <div align="center">
      <p>{{$t('syncPartnerGoodsStock.confirmContent')}}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeSyncPartnerGoodsStockModel">{{$t('syncPartnerGoodsStock.cancel')}}</el-button>
      <el-button type="primary" @click="syncPartnerGoodsStock">{{$t('syncPartnerGoodsStock.confirm')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { syncPartnerGoodsStock } from '@/api/partner/syncPartnerGoodsStockApi'

export default {
  name: 'SyncPartnerGoodsStock',
  data() {
    return {
      dialogVisible: false,
      syncPartnerGoodsStockInfo: {}
    }
  },
  methods: {
    open(data) {
      this.syncPartnerGoodsStockInfo = { ...data }
      this.dialogVisible = true
    },
    syncPartnerGoodsStock() {
      this.syncPartnerGoodsStockInfo.shopId = getShopId()
      syncPartnerGoodsStock(this.syncPartnerGoodsStockInfo)
        .then(res => {
          if (res.code === 0) {
            this.$message.success(this.$t('syncPartnerGoodsStock.syncSuccess'))
            this.dialogVisible = false
            this.$emit('refresh')
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(err => {
          this.$message.error(err.message || this.$t('common.requestFailed'))
        })
    },
    closeSyncPartnerGoodsStockModel() {
      this.dialogVisible = false
    },
    handleClose(done) {
      done()
    }
  }
}
</script>